import ajax from '../../lib/ajax';
import warehouseInfoDetail from '../entities/warehouseinfodetail'
const warehouseInfoModule = {
    namespaced: true,
    state: {

    },
    actions: {
        async getAll(state: any, payload: any) {
            let rep = await ajax.get('/api/services/app/WarehouseInfo/GetWarehouseInfoDetail', { params: payload.data });
            return rep.data.result as Array<warehouseInfoDetail>;
        },
    }
}
export default warehouseInfoModule;